export default __webpack_public_path__ + "static/media/5.aadbc4bb.png";